"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMO_CARD_MANIFEST = void 0;
const CardName_1 = require("../../CardName");
const GameModule_1 = require("../../GameModule");
const CardManifest_1 = require("../CardManifest");
const Advertising_1 = require("./Advertising");
const ArcadianCommunities_1 = require("./ArcadianCommunities");
const AsteroidDeflectionSystem_1 = require("./AsteroidDeflectionSystem");
const AsteroidHollowing_1 = require("./AsteroidHollowing");
const AsteroidRights_1 = require("./AsteroidRights");
const Astrodrill_1 = require("./Astrodrill");
const CometAiming_1 = require("./CometAiming");
const CrashSiteCleanup_1 = require("./CrashSiteCleanup");
const CuttingEdgeTechnology_1 = require("./CuttingEdgeTechnology");
const DeimosDownPromo_1 = require("./DeimosDownPromo");
const DirectedImpactors_1 = require("./DirectedImpactors");
const DiversitySupport_1 = require("./DiversitySupport");
const DuskLaserMining_1 = require("./DuskLaserMining");
const EnergyMarket_1 = require("./EnergyMarket");
const Factorum_1 = require("./Factorum");
const FieldCappedCity_1 = require("./FieldCappedCity");
const GreatDamPromo_1 = require("./GreatDamPromo");
const HiTechLab_1 = require("./HiTechLab");
const ImportedNutrients_1 = require("./ImportedNutrients");
const InterplanetaryTrade_1 = require("./InterplanetaryTrade");
const JovianEmbassy_1 = require("./JovianEmbassy");
const LawSuit_1 = require("./LawSuit");
const MagneticFieldGeneratorsPromo_1 = require("./MagneticFieldGeneratorsPromo");
const MagneticShield_1 = require("./MagneticShield");
const MeatIndustry_1 = require("./MeatIndustry");
const Meltworks_1 = require("./Meltworks");
const MercurianAlloys_1 = require("./MercurianAlloys");
const MoholeLake_1 = require("./MoholeLake");
const MonsInsurance_1 = require("./MonsInsurance");
const OrbitalCleanup_1 = require("./OrbitalCleanup");
const Penguins_1 = require("./Penguins");
const PharmacyUnion_1 = require("./PharmacyUnion");
const Philares_1 = require("./Philares");
const Potatoes_1 = require("./Potatoes");
const ProjectInspection_1 = require("./ProjectInspection");
const Recyclon_1 = require("./Recyclon");
const RegoPlastics_1 = require("./RegoPlastics");
const SaturnSurfing_1 = require("./SaturnSurfing");
const SelfReplicatingRobots_1 = require("./SelfReplicatingRobots");
const SmallAsteroid_1 = require("./SmallAsteroid");
const SnowAlgae_1 = require("./SnowAlgae");
const Splice_1 = require("./Splice");
const StanfordTorus_1 = require("./StanfordTorus");
const SubCrustMeasurements_1 = require("./SubCrustMeasurements");
const TopsoilContract_1 = require("./TopsoilContract");
const BioPrintingFacility_1 = require("./BioPrintingFacility");
const BactoviralResearch_1 = require("./BactoviralResearch");
const Harvest_1 = require("./Harvest");
const OutdoorSports_1 = require("./OutdoorSports");
const NewPartner_1 = require("./NewPartner");
const Merger_1 = require("./Merger");
const CorporateArchives_1 = require("./CorporateArchives");
const DoubleDown_1 = require("./DoubleDown");
const HeadStart_1 = require("./HeadStart");
const _16Psyche_1 = require("./16Psyche");
const RobotPollinators_1 = require("./RobotPollinators");
const Supercapacitors_1 = require("./Supercapacitors");
const DirectedHeatUsage_1 = require("./DirectedHeatUsage");
const FloydContinuum_1 = require("./FloydContinuum");
const IcyImpactors_1 = require("./IcyImpactors");
const SoilEnrichment_1 = require("./SoilEnrichment");
const CityPark_1 = require("./CityPark");
const Supermarkets_1 = require("./Supermarkets");
const NewHolland_1 = require("./NewHolland");
const Hospitals_1 = require("./Hospitals");
const Casinos_1 = require("./Casinos");
const PublicBaths_1 = require("./PublicBaths");
const ProtectedGrowth_1 = require("./ProtectedGrowth");
const Vermin_1 = require("./Vermin");
exports.PROMO_CARD_MANIFEST = new CardManifest_1.CardManifest({
    module: GameModule_1.GameModule.Promo,
    projectCards: [
        { cardName: CardName_1.CardName.PENGUINS, Factory: Penguins_1.Penguins },
        { cardName: CardName_1.CardName.SELF_REPLICATING_ROBOTS, Factory: SelfReplicatingRobots_1.SelfReplicatingRobots },
        { cardName: CardName_1.CardName.SMALL_ASTEROID, Factory: SmallAsteroid_1.SmallAsteroid },
        { cardName: CardName_1.CardName.SNOW_ALGAE, Factory: SnowAlgae_1.SnowAlgae },
        { cardName: CardName_1.CardName.DUSK_LASER_MINING, Factory: DuskLaserMining_1.DuskLaserMining },
        { cardName: CardName_1.CardName.MERCURIAN_ALLOYS, Factory: MercurianAlloys_1.MercurianAlloys },
        { cardName: CardName_1.CardName.REGO_PLASTICS, Factory: RegoPlastics_1.RegoPlastics },
        { cardName: CardName_1.CardName.INTERPLANETARY_TRADE, Factory: InterplanetaryTrade_1.InterplanetaryTrade },
        { cardName: CardName_1.CardName.ORBITAL_CLEANUP, Factory: OrbitalCleanup_1.OrbitalCleanup },
        { cardName: CardName_1.CardName.PROJECT_INSPECTION, Factory: ProjectInspection_1.ProjectInspection },
        { cardName: CardName_1.CardName.HI_TECH_LAB, Factory: HiTechLab_1.HiTechLab },
        { cardName: CardName_1.CardName.ENERGY_MARKET, Factory: EnergyMarket_1.EnergyMarket },
        { cardName: CardName_1.CardName.LAW_SUIT, Factory: LawSuit_1.LawSuit },
        { cardName: CardName_1.CardName.STANFORD_TORUS, Factory: StanfordTorus_1.StanfordTorus },
        { cardName: CardName_1.CardName.ASTEROID_HOLLOWING, Factory: AsteroidHollowing_1.AsteroidHollowing },
        { cardName: CardName_1.CardName.ASTEROID_RIGHTS, Factory: AsteroidRights_1.AsteroidRights },
        { cardName: CardName_1.CardName.COMET_AIMING, Factory: CometAiming_1.CometAiming },
        { cardName: CardName_1.CardName.CUTTING_EDGE_TECHNOLOGY, Factory: CuttingEdgeTechnology_1.CuttingEdgeTechnology },
        { cardName: CardName_1.CardName.CRASH_SITE_CLEANUP, Factory: CrashSiteCleanup_1.CrashSiteCleanup },
        { cardName: CardName_1.CardName.DIRECTED_IMPACTORS, Factory: DirectedImpactors_1.DirectedImpactors },
        { cardName: CardName_1.CardName.FIELD_CAPPED_CITY, Factory: FieldCappedCity_1.FieldCappedCity },
        { cardName: CardName_1.CardName.MAGNETIC_SHIELD, Factory: MagneticShield_1.MagneticShield },
        { cardName: CardName_1.CardName.MELTWORKS, Factory: Meltworks_1.Meltworks },
        { cardName: CardName_1.CardName.MOHOLE_LAKE, Factory: MoholeLake_1.MoholeLake },
        { cardName: CardName_1.CardName.DIVERSITY_SUPPORT, Factory: DiversitySupport_1.DiversitySupport },
        { cardName: CardName_1.CardName.JOVIAN_EMBASSY, Factory: JovianEmbassy_1.JovianEmbassy },
        { cardName: CardName_1.CardName.TOPSOIL_CONTRACT, Factory: TopsoilContract_1.TopsoilContract },
        { cardName: CardName_1.CardName.IMPORTED_NUTRIENTS, Factory: ImportedNutrients_1.ImportedNutrients },
        { cardName: CardName_1.CardName.ASTEROID_DEFLECTION_SYSTEM, Factory: AsteroidDeflectionSystem_1.AsteroidDeflectionSystem },
        { cardName: CardName_1.CardName.SUB_CRUST_MEASUREMENTS, Factory: SubCrustMeasurements_1.SubCrustMeasurements },
        { cardName: CardName_1.CardName.POTATOES, Factory: Potatoes_1.Potatoes },
        { cardName: CardName_1.CardName.MEAT_INDUSTRY, Factory: MeatIndustry_1.MeatIndustry },
        { cardName: CardName_1.CardName.ADVERTISING, Factory: Advertising_1.Advertising },
        { cardName: CardName_1.CardName.DEIMOS_DOWN_PROMO, Factory: DeimosDownPromo_1.DeimosDownPromo },
        { cardName: CardName_1.CardName.GREAT_DAM_PROMO, Factory: GreatDamPromo_1.GreatDamPromo },
        { cardName: CardName_1.CardName.MAGNETIC_FIELD_GENERATORS_PROMO, Factory: MagneticFieldGeneratorsPromo_1.MagneticFieldGeneratorsPromo },
        { cardName: CardName_1.CardName.SATURN_SURFING, Factory: SaturnSurfing_1.SaturnSurfing },
        { cardName: CardName_1.CardName.BIO_PRINTING_FACILITY, Factory: BioPrintingFacility_1.BioPrintingFacility },
        { cardName: CardName_1.CardName.BACTOVIRAL_RESEARCH, Factory: BactoviralResearch_1.BactoviralResearch },
        { cardName: CardName_1.CardName.HARVEST, Factory: Harvest_1.Harvest },
        { cardName: CardName_1.CardName.OUTDOOR_SPORTS, Factory: OutdoorSports_1.OutdoorSports },
        { cardName: CardName_1.CardName.SIXTEEN_PSYCHE, Factory: _16Psyche_1.SixteenPsyche },
        { cardName: CardName_1.CardName.ROBOT_POLLINATORS, Factory: RobotPollinators_1.RobotPollinators },
        { cardName: CardName_1.CardName.SUPERCAPACITORS, Factory: Supercapacitors_1.Supercapacitors },
        { cardName: CardName_1.CardName.DIRECTED_HEAT_USAGE, Factory: DirectedHeatUsage_1.DirectedHeatUsage },
        { cardName: CardName_1.CardName.FLOYD_CONTINUUM, Factory: FloydContinuum_1.FloydContinuum },
        { cardName: CardName_1.CardName.ICY_IMPACTORS, Factory: IcyImpactors_1.IcyImpactors },
        { cardName: CardName_1.CardName.SOIL_ENRICHMENT, Factory: SoilEnrichment_1.SoilEnrichment },
        { cardName: CardName_1.CardName.CITY_PARK, Factory: CityPark_1.CityPark },
        { cardName: CardName_1.CardName.SUPERMARKETS, Factory: Supermarkets_1.Supermarkets },
        { cardName: CardName_1.CardName.NEW_HOLLAND, Factory: NewHolland_1.NewHolland },
        { cardName: CardName_1.CardName.HOSPITALS, Factory: Hospitals_1.Hospitals },
        { cardName: CardName_1.CardName.CASINOS, Factory: Casinos_1.Casinos },
        { cardName: CardName_1.CardName.PUBLIC_BATHS, Factory: PublicBaths_1.PublicBaths },
        { cardName: CardName_1.CardName.PROTECTED_GROWTH, Factory: ProtectedGrowth_1.ProtectedGrowth },
        { cardName: CardName_1.CardName.VERMIN, Factory: Vermin_1.Vermin },
    ],
    preludeCards: [
        { cardName: CardName_1.CardName.NEW_PARTNER, Factory: NewPartner_1.NewPartner },
        { cardName: CardName_1.CardName.MERGER, Factory: Merger_1.Merger },
        { cardName: CardName_1.CardName.CORPORATE_ARCHIVES, Factory: CorporateArchives_1.CorporateArchives },
        { cardName: CardName_1.CardName.DOUBLE_DOWN, Factory: DoubleDown_1.DoubleDown },
        { cardName: CardName_1.CardName.HEAD_START, Factory: HeadStart_1.HeadStart },
    ],
    cardsToRemove: [
        CardName_1.CardName.DEIMOS_DOWN,
        CardName_1.CardName.GREAT_DAM,
        CardName_1.CardName.MAGNETIC_FIELD_GENERATORS
    ],
    corporationCards: [
        { cardName: CardName_1.CardName.ARCADIAN_COMMUNITIES, Factory: ArcadianCommunities_1.ArcadianCommunities },
        { cardName: CardName_1.CardName.ASTRODRILL, Factory: Astrodrill_1.Astrodrill },
        { cardName: CardName_1.CardName.FACTORUM, Factory: Factorum_1.Factorum },
        { cardName: CardName_1.CardName.PHARMACY_UNION, Factory: PharmacyUnion_1.PharmacyUnion },
        { cardName: CardName_1.CardName.PHILARES, Factory: Philares_1.Philares },
        { cardName: CardName_1.CardName.MONS_INSURANCE, Factory: MonsInsurance_1.MonsInsurance },
        { cardName: CardName_1.CardName.RECYCLON, Factory: Recyclon_1.Recyclon },
        { cardName: CardName_1.CardName.SPLICE, Factory: Splice_1.Splice },
    ]
});
//# sourceMappingURL=PromoCardManifest.js.map